import * as React from "react";
import AppRouter from "./components/AppRouter";
import { observer } from "mobx-react-lite";




const App = observer(function App(props) {
  return (
    <div>
      <AppRouter model={props.model} />
    </div>
  );
});

export default App;
